import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./styles/index.scss"; // 全局样式
import Vant from "vant";
import "vant/lib/index.css";
import "amfe-flexible";

import VConsole from "vconsole";

if (process.env.NODE_ENV === "development") {
  new VConsole({ theme: "dark" });
}

// vConsole.destroy();

Vue.use(Vant);
Vue.config.productionTip = false;
console.log(process.env);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
